/**
 * @react-native-community/netinfo stub for web
 * Provides mock network information API
 */

declare const window: any;
declare const navigator: any;

// Mock NetInfo state
type NetInfoState = {
  isConnected: boolean;
  isInternetReachable: boolean;
  type: string;
  details: any;
};

let listeners: Set<(state: NetInfoState) => void> = new Set();

// Simulate initial state
let currentState: NetInfoState = {
  isConnected: true,
  isInternetReachable: true,
  type: 'wifi',
  details: { strength: -40, frequency: 2437 },
};

// Listen to online/offline events
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    currentState = { ...currentState, isConnected: true, isInternetReachable: true };
    listeners.forEach((listener) => listener(currentState));
  });

  window.addEventListener('offline', () => {
    currentState = { ...currentState, isConnected: false, isInternetReachable: false };
    listeners.forEach((listener) => listener(currentState));
  });
}

export const fetch = async (): Promise<NetInfoState> => {
  return currentState;
};

export const addEventListener = (listener: (state: NetInfoState) => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const isConnected = {
  fetch: async (): Promise<boolean> => currentState.isConnected,
  addEventListener: (listener: (isConnected: boolean) => void) => {
    const wrappedListener = (state: NetInfoState) => listener(state.isConnected);
    listeners.add(wrappedListener);
    return () => listeners.delete(wrappedListener);
  },
};

export const isInternetReachable = {
  fetch: async (): Promise<boolean> => currentState.isInternetReachable,
  addEventListener: (listener: (isReachable: boolean) => void) => {
    const wrappedListener = (state: NetInfoState) => listener(state.isInternetReachable);
    listeners.add(wrappedListener);
    return () => listeners.delete(wrappedListener);
  },
};

export default {
  fetch,
  addEventListener,
  isConnected,
  isInternetReachable,
};
